import React from 'react';
import Table from '../Table';
import propTypes from 'prop-types';
import { Row, Col, Button, Label } from 'reactstrap';


export default class AddRateTableWidget extends React.Component {
  constructor(props) {
    super(props);
    //this.onPreviewButtonClick = this.onPreviewButtonClick.bind(this);
    this.onGridRowsUpdated = this.onGridRowsUpdated.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.state = {
      previewed: false,
      data: []
    };
  }
  addRow() {
    let rows = this.state.data;
    rows.push({

    });

    this.setState({
      data: rows
    });
  }

  removeRow() {
    let rows = this.state.data;
    if (rows.length > 0) {
      rows.splice(-1, 1);
      this.setState({
        data: rows
      });
    }
  }

  onGridRowsUpdated(rows) {
    this.setState({
      data: rows
    });
  }


  render() {
    let { columns, onReject, onAccept } = this.props;
    let { data } = this.state;

    // accept button calls on complete and on accept changes
    let accept = <Button onClick={() => {
      onAccept(data);
    }} type="submit" className="btn btn-success disable">Accept</Button>;

    
    return (
      <Row>
        <Col sm="12">
          <div className='pb-3'>
            <Button color="primary" onClick={this.removeRow}>Remove Row</Button>{'  '}
            <Button color="primary" onClick={this.addRow}>Add Row</Button> {'  '}           
          </div>
          <Table
            entity={null}
            data={data || []}
            //addRowView={true}
            columns={columns}            
            onGridRowsUpdated={this.onGridRowsUpdated}
          />
        </Col>
        <Col sm="12">
          <button onClick={onReject} className="btn btn-danger">Reject</button>
          &nbsp;
         {/*this.state.previewed ? accept : null*/ accept}
         <Label className='pl-3'> *Only complete rows will be accepted.*</Label>
        </Col>
      </Row>

    );
  }

}


// WEBPACK FOOTER //
// ./src/components/RateManagment/AddRateTableWidget.js